import keymirror from 'js/utils/keymirror';
import { callApi, noSchemaQuerySuccessMutator } from 'js/api';
import { request } from 'js/api/axios';
import { extractApiKeys, spreadApiKeys } from 'js/utils';

export const types = keymirror({
  ...spreadApiKeys('FETCH_SPRINT_REPORT'),
});

/**
 * params: optional query parameters, e.g. { removed_statuses: '' } to count no status as removed.
 */
export function fetchSprintReport(
  teamId,
  connectorId,
  queryId = null,
  params = {}
) {
  const meta = { queryId };
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.FETCH_SPRINT_REPORT, types),
        request: (_data, token, currentWorkspaceId) =>
          request.get(
            `/api/workspaces/${currentWorkspaceId}/teams/${teamId}/connectors/${connectorId}/sprint-report`,
            {
              params,
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        meta,
        mutators: [undefined, noSchemaQuerySuccessMutator(meta), undefined],
        // schema: SCHEMAS.SPRINT_REPORT,
      },
      dispatch
    );
  };
}
